'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'house-chimney';
var width = 512;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = ['M64 198.1L64 456c0 22.1 17.9 40 40 40l72 0 0-120c0-30.9 25.1-56 56-56l48 0c30.9 0 56 25.1 56 56l0 120 72 0c22.1 0 40-17.9 40-40L448 198.1 256 18.9 64 198.1zM384 64l0 52.5 64 59.7 0-112.3c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z', 'M266.9 7.2c-6.1-5.7-15.7-5.7-21.8 0L10.5 226.2c-3.2 3-3.4 8.1-.4 11.3s8.1 3.4 11.3 .4L48 213.1 48 456c0 30.9 25.1 56 56 56l304 0c30.9 0 56-25.1 56-56l0-242.9 26.5 24.8c3.2 3 8.3 2.8 11.3-.4s2.8-8.3-.4-11.3L464 191.2 464 64c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 37.6-101.1-94.3zM448 198.1L448 456c0 22.1-17.9 40-40 40l-72 0 0-120c0-30.9-25.1-56-56-56l-48 0c-30.9 0-56 25.1-56 56l0 120-72 0c-22.1 0-40-17.9-40-40L64 198.1 256 18.9 448 198.1zM192 496l0-120c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 120-128 0zM448 64l0 112.3-64-59.7 0-52.5c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;